import { action, atom, Ctx } from "@reatom/framework";
import { filterLinks } from "src/util";

const initialSpuLinksAtom = atom("", "initialSpuLinksAtom");

const formatAction = action((ctx: Ctx) => {
  const links = ctx.get(initialSpuLinksAtom);
  return initialSpuLinksAtom(
    ctx,
    filterLinks(links)
      .map((item) => item.link)
      .join("\n"),
  );
});

export const initialSpuLinksStore = {
  formatAction,
  initialSpuLinksAtom,
};
